import { Helmet } from "react-helmet-async";
import { SEO } from "@/data/content";

const KEYWORDS =
    "AgentVM, AI agents, verifiable agents, trusted execution, TEE, attestation, execution proof, private AI, agentic economy, Arc, Circle, AI infrastructure";

export const Seo = ({ path }) => {
    const meta = SEO[path] || SEO["/"];
    return (
        <Helmet>
            <title>{meta.title}</title>
            <meta name="description" content={meta.desc} />
            <meta name="keywords" content={KEYWORDS} />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.desc} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="AgentVM" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={meta.title} />
            <meta name="twitter:description" content={meta.desc} />
        </Helmet>
    );
};
